module.exports = __webpack_public_path__ + "img/infoguidance_mov_02.e4d6284a.jpg";